import styled from "styled-components";
import { motion } from "framer-motion";

export const PG = styled(motion.div)`
    min-width: 290px;
    width: calc(25% - 20px);
    height: 230px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    position: relative;

    &[data-segmento="Insumos"] { 
        width: calc(50% - 15px);
    }

    @media (max-width: 1480px) {
        min-width: 285px;
        width: calc(52% - 20px);
    }

    div.PG__content {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    div.PG__labels {
        width: 100%;
        display: flex;
        gap: 10px;

        div.PG__labels__item {
            display: flex;
            align-items: center;
            gap: 5px;

            div.PG__labels__item__circle {
                width: 12px;
                min-width: 12px;
                height: 12px;
                min-height: 12px;
                background: var(--primary-color);
                border-radius: 100%;
            }

            span.PG__labels__item__lebel {
                font-size: 11px;
                white-space: nowrap;
                color: var(--text-color);
                font-weight: 500;
            }
        }
    }

`;